import type { ReactNode } from "react";
import { Box, type SxProps, type Theme } from "@mui/material";
import "./responsiveList.css";

export function ResponsiveListSurface(props: {
  children: ReactNode;
  variant:
    | "table"
    | "tabContent"
    | "compactTabContent"
    | "compactStandalone"
    | "compactNarrowTabContent"
    | "compactNarrowStandalone";
  sx?: SxProps<Theme>;
  "data-testid"?: string;
}) {
  const { children, variant, sx, "data-testid": dataTestId } = props;
  const tableSurface = variant === "table";
  const compactVertical = !tableSurface && variant !== "tabContent";
  const connectedToTabs = !tableSurface && variant !== "compactStandalone" && variant !== "compactNarrowStandalone";
  const narrowHorizontalPadding = variant === "compactNarrowTabContent" || variant === "compactNarrowStandalone";

  return (
    <Box
      className="responsive-list"
      data-testid={dataTestId}
      sx={[
        {
          position: "relative",
          backgroundColor: "background.paper",
          borderRadius: "16px",
          borderTopLeftRadius: connectedToTabs ? { xs: "16px", sm: 0 } : "16px",
          boxSizing: "border-box",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "hidden",
          padding: tableSurface
            ? 0
            : compactVertical
              ? { xs: "20px 20px 10px", sm: narrowHorizontalPadding ? "10px 20px" : "10px 30px" }
              : "20px",
          width: "100%",
          "& .RaDatagrid-root": {
            boxShadow: "none",
            ...(tableSurface ? { borderRadius: 0, overflowX: "auto" } : {}),
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  );
}
